/// 顶部 --- 统计数据
export const totalConfig = {
    
    
    
    
    "MN为第一陈列": "45%",
    "YL为第一陈列": "23%",
    "JLB为第一陈列": "6.0%",
    "QT为第一陈列": "24%",
  }
  
  /// ----
  export const tableDataArr1 = {
    "product": ["07-01","07-02","07-03","07-04","07-05","07-06","07-07","07-08"],
    
    "YL为第一陈列": [21,21,12,14,13,16,15,17],
    "JLB为第一陈列": [5,5,6,8,3,7,5,2,7,6,4,5],
    "QT为第一陈列": [23,23,14,23,35,28,30,23,24],
    // "MN为第一陈列": [52,51,64,44,54,54,52,49],
    "MN为第一陈列": [8,22,3,12,30,30,19,12],
  }

  export const tableDataArr2 = {
    "product": ["北京","西北","豫皖","山东","华中","东北","华北","华东","上海","华南","西南","闽赣"],
    
      "YL为第一陈列": [24,21,21,13,12,14,14,17,5,8,4,30],
      "JLB为第一陈列": [8,8,36,1,2,4,5,3,2,1,1,2],
      "QT为第一陈列": [8,22,3,12,30,30,19,12,62,41,47,6],
      // "MN为第一陈列": [40,51,69,50,71,68,38,60,61,71,30,52],
      "MN为第一陈列": [23,23,14,23,35,28,30,23,24,42,41,47],
  }

  
  export const tableDimensionArr = ["product",  "MN为第一陈列","YL为第一陈列", "JLB为第一陈列", "QT为第一陈列",]
  
  ///
  export const modernChartDataArr = [
    {
      "type": "line",
      "barWidth": "70%",
      "label": {
        "normal": {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        }
      },
      "animationDuration": 2800,
      "animationEasing": "cubicInOut"
    },
    {
      "type": "line",
      "barWidth": "70%",
      "label": {
        "normal": {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        }
      },
      "animationDuration": 2800,
      "animationEasing": "cubicInOut"
    },
    {
      "type": "line",
      "barWidth": "70%",
      "label": {
        "normal": {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        }
      },
      "animationDuration": 2800,
      "animationEasing": "cubicInOut"
    },
    {
      "type": "line",
      "barWidth": "70%",
      "label": {
        "normal": {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        }
      },
      "animationDuration": 2800,
      "animationEasing": "cubicInOut"
    },
    // {
    //   "type": "line",
    //   "barWidth": "70%",
    //   "label": {
    //     "normal": {
    //       "show": true,
    //       "color": "black",
    //       "fontSize": 10,
    //       "position": "inside"
    //     }
    //   },
    //   "animationDuration": 2800,
    //   "animationEasing": "cubicInOut"
    // },
    // {
    //   "type": "line",
    //   "barWidth": "70%",
    //   "label": {
    //     "normal": {
    //       "show": true,
    //       "color": "black",
    //       "fontSize": 10,
    //       "position": "inside"
    //     }
    //   },
    //   "animationDuration": 2800,
    //   "animationEasing": "cubicInOut"
    // }
  ]
  
  
  


// WEBPACK FOOTER //
// ./src/components/kpi/config/AllDisplay.js